import classes from './Inputs.module.css';
import { Checkbox, CheckboxProps } from '@mantine/core';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledCheckboxProps = CheckboxProps & { capabilityFieldId?: string };

const StyledCheckbox = ({ capabilityFieldId, ...props }: StyledCheckboxProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  return (
    <Checkbox
      {...props}
      label={label}
      classNames={{
        input: classes.input,
        label: classes.label,
      }}
    />
  );
};

export default StyledCheckbox;
